import { z } from "zod";

import { addressSchema } from "./address-schema.ts";

export const canteiroSchema = z.object({
	name: z.string().trim().min(1, "Informe o nome do canteiro"),
	...addressSchema.shape,
	area: z.string().trim().optional(),
	startDate: z.string().optional(),
	expectedEndDate: z.string().optional(),
});

export type CanteiroFormValues = z.infer<typeof canteiroSchema>;
